import dayjs from "dayjs";

/**
 * Get time of day label from a given datetime
 * @param {string|Date} datetime - Any date/time parseable by dayjs
 * @returns {"morning"|"day"|"evening"|"night"}
 */
export const getTimeOfDay = (datetime) => {
  const hour = dayjs(datetime).hour();

  if (hour >= 5 && hour < 12) return "morning";   // 5 AM - 12 PM
  if (hour >= 12 && hour < 17) return "day";      // 12 PM - 5 PM
  if (hour >= 17 && hour < 21) return "evening";  // 5 PM - 9 PM
  return "night";                                 // 9 PM - 5 AM
};

// 🧠 Example usage:
console.log(getTimeOfDay("2025-10-18T06:00")); // morning
console.log(getTimeOfDay("2025-10-18T13:30")); // day
console.log(getTimeOfDay("2025-10-18T19:00")); // evening
console.log(getTimeOfDay("2025-10-18T23:45")); // night
